export default __webpack_public_path__ + "static/media/top.cc18c925.png";